module.exports = __webpack_public_path__ + "static/OTM-1e155ac6683b4416f0a18efd7e5df8b3.png";